import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import '@fontsource/poppins';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import { ThemeContextProvider } from './lib/ThemeContext';
import AuthProvider from './lib/auth/AuthProvider';
import './lib/i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ThemeContextProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeContextProvider>
);
